import React, { useState, useEffect, useMemo, useRef } from "react";
import jsPDF from "jspdf";
import { Link } from "react-router-dom";
import swal from "sweetalert";
import {
  Box,
  Container,
  Paper,
  TextField,
  Button,
  Typography,
  Tabs,
  Tab,
  Card,
  CardContent,
  CardActions,
  Chip,
  IconButton,
  Menu,
  MenuItem,
  Checkbox,
  FormControlLabel,
  InputAdornment,
  Divider,
  Fade,
  Avatar,
  Badge,
  Select,
  FormControl,
  Accordion,
  AccordionSummary,
  AccordionDetails,
  Tooltip,
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  InputLabel,
  Breadcrumbs,
  tooltipClasses,
  Stack,
} from "@mui/material";
import Poetlogopen from "../../static/POET_Logo_Pen.png";
import { makeStyles, useTheme, withStyles } from "@material-ui/core/styles";
import Grid2 from "@mui/material/Unstable_Grid2";
import NavigateNextIcon from "@mui/icons-material/NavigateNext";
import {
  Search,
  Add,
  Delete,
  FileCopy,
  GetApp,
  Sort,
  ViewModule,
  MoreVert,
  Link as LinkIcon,
  MenuBook,
  Description,
  Language,
  CloudDownload,
  Close,
  AssignmentTurnedIn,
  ExpandMore,
  ContentCopy as ContentCopyIcon,
  OpenInNew,
  EditRoad,
  Edit,
  AutoFixHigh,
  Psychology,
  Send,
} from "@mui/icons-material";
import CloseIcon from "@mui/icons-material/Close";
import { styled } from "@mui/material/styles";
import { checkAIRequestLimit } from "../aiRequestLimit";
import citationService from "../../services/citationService";
import { useSelector } from "react-redux";
import Loader from "../../utils/loader";
import { addUserLogs } from "../../services/userLogServices";
import SubscriptionRequired from "../../components/SubscriptionRequired";
// import { useCheckFeatureAccess } from "../../CheckFeature";
import { useCheckSubscriptionPlanAccess } from "../../components/SubscriptionAccess";
import { useHistory } from "react-router-dom";
import jwtDecode from "jwt-decode";
import { aiSmartDesk } from "../../services/aiIntelligenzServices";

const LightTooltip = styled(({ className, ...props }) => (
  <Tooltip {...props} classes={{ popper: className }} />
))(({ theme }) => ({
  zIndex: 10000,
  [`& .${tooltipClasses.tooltip}`]: {
    backgroundColor: "#ffffff",
    color: "#1976d2",
    boxShadow: theme.shadows[3],
    fontSize: 12,
    border: "1px solid #e0e0e0",
  },
}));
const citationStyles = [
  "AMA 10th edition",
  "American Chemical Society",
  "APA 11th edition",
  "APA 6th edition",
  "APA 7th edition",
  "Chicago author",
];

const sourceTypes = [
  { value: "Book Chapter", name: "BOOK CHAPTER" },
  { value: "Video", name: "VIDEO" },
  { value: "Online Dictionary Entry", name: "ONLINE DICTIONARY ENTRY" },
  { value: "Online News Article", name: "ONLINE NEWS ARTICLE" },
  { value: "Image", name: "IMAGE" },
  { value: "Report", name: "REPORT" },
  { value: "Website", name: "WEBSITE" },
];

const Toast = ({ message, type, onClose }) => {
  useEffect(() => {
    const timer = setTimeout(onClose, 3000);
    return () => clearTimeout(timer);
  }, [onClose]);

  const bgColor =
    type === "success"
      ? "#4caf50"
      : type === "error"
        ? "#f44336"
        : type === "warning"
          ? "#ff9800"
          : "#2196f3";

  return (
    <Box
      sx={{
        position: "fixed",
        top: 20,
        right: 20,
        bgcolor: bgColor,
        color: "white",
        px: 3,
        py: 2,
        borderRadius: 2,
        boxShadow: 3,
        zIndex: 9999,
        minWidth: 250,
      }}
    >
      {message}
    </Box>
  );
};

const stripHtmlTags = (text) => {
  if (!text) return "";
  return text.replace(/<[^>]*>/g, "");
};

const cleanCitationData = (citation) => {
  if (!citation) return citation;

  const cleaned = { ...citation };

  if (cleaned.title) cleaned.title = stripHtmlTags(cleaned.title);
  if (cleaned.fullCitation)
    cleaned.fullCitation = stripHtmlTags(cleaned.fullCitation);
  if (cleaned.description)
    cleaned.description = stripHtmlTags(cleaned.description);
  if (cleaned.websiteName)
    cleaned.websiteName = stripHtmlTags(cleaned.websiteName);
  if (cleaned.contributors && Array.isArray(cleaned.contributors)) {
    cleaned.contributors = cleaned.contributors.map((contributor) => ({
      ...contributor,
      firstName: contributor.firstName
        ? stripHtmlTags(contributor.firstName)
        : "",
      lastName: contributor.lastName ? stripHtmlTags(contributor.lastName) : "",
      middleName: contributor.middleName
        ? stripHtmlTags(contributor.middleName)
        : "",
      suffix: contributor.suffix ? stripHtmlTags(contributor.suffix) : "",
    }));
  }

  return cleaned;
};

const ModernCitationGenerator = ({ userId }) => {
  const [selectedTab, setSelectedTab] = useState(0);
  const [initialCitations, setInitialCitations] = useState([]);
  const [citations, setCitations] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [citationStyle, setCitationStyle] = useState("APA 7th edition");
  const [searchInput, setSearchInput] = useState("");
  const [downloadAnchor, setDownloadAnchor] = useState(null);
  const [groupByAnchor, setGroupByAnchor] = useState(null);
  const [selectAll, setSelectAll] = useState(false);
  const [cardMenuAnchor, setCardMenuAnchor] = useState(null);
  const [selectedCardId, setSelectedCardId] = useState(null);
  const [sortOrder, setSortOrder] = useState("asc");
  const [websiteData, setWebsiteData] = useState(null);
  const [displayByDate, setDisplayByDate] = useState(false);
  const [totalSearchedSource, setTotalSearchedSource] = useState(0);
  const [totalSource, setTotalSource] = useState(0);
  const [toast, setToast] = useState(null);
  const [showManualModal, setShowManualModal] = useState(false);
  const [showEditModal, setShowEditModal] = useState(false);
  const [editingCitation, setEditingCitation] = useState(null);
  const [subReqOpen, setSubReqOpen] = useState(false);
  const history = useHistory();
  const accessToCitationScreen = useCheckSubscriptionPlanAccess("citation");
  const accessToCiteManually = useCheckSubscriptionPlanAccess("citeManually");
  const [isFeatureInside, setIsFeatureInside] = useState(false);
  const [loading, setLoading] = useState(false);
  const userDetails = useSelector((user) => user);

  //  const userID = userId ? userId : userDetails.user.currentUser._id;

  const [sdOpen, setSdOpen] = useState(false);
  const [sdConv, setSdConv] = useState([]);
  const [sdMsg, setSdMsg] = useState("");
  const [sdLoading, setSdLoading] = useState(false);
  const [sdEditingId, setSdEditingId] = useState(null);
  const [sdEditContent, setSdEditContent] = useState("");
  const sdEndRef = useRef(null);
  const sdGenId = () =>
    Date.now().toString() + Math.random().toString(36).slice(2, 8);

  // Dark mode state
  const [isDarkMode, setIsDarkMode] = useState(false);
  useEffect(() => {
    const updateTheme = () => {
      const theme = localStorage.getItem("ThemeSwitch");
      setIsDarkMode(theme === "true");
    };
    updateTheme();
    window.addEventListener("storage", updateTheme);
    const originalSetItem = localStorage.setItem;
    localStorage.setItem = function (key, value) {
      originalSetItem.apply(this, arguments);
      if (key === "ThemeSwitch") updateTheme();
    };
    return () => {
      window.removeEventListener("storage", updateTheme);
      localStorage.setItem = originalSetItem;
    };
  }, []);

  // SmartDesk scroll to bottom
  useEffect(() => {
    sdEndRef.current?.scrollIntoView({ behavior: "smooth" });
  }, [sdConv, sdLoading]);

  // ── SmartDesk send ──
  const sdSend = async (text) => {
    const txt = (text || sdMsg).trim();
    if (!txt || sdLoading) return;
    const userMsg = {
      id: sdGenId(),
      type: "user",
      content: txt,
      ts: new Date(),
    };
    setSdConv((prev) => [...prev, userMsg]);
    setSdMsg("");
    setSdLoading(true);
    try {
      const res = await aiSmartDesk(txt, "");
      const reply =
        res.data?.data?.response ||
        res.data?.response ||
        (typeof res.data === "string"
          ? res.data
          : "I couldn't parse that response.");
      setSdConv((prev) => [
        ...prev,
        { id: sdGenId(), type: "ai", content: reply, ts: new Date() },
      ]);
    } catch (e) {
      setSdConv((prev) => [
        ...prev,
        {
          id: sdGenId(),
          type: "ai",
          content: "Error: " + (e.message || "something went wrong"),
          ts: new Date(),
          isError: true,
        },
      ]);
    }
    setSdLoading(false);
  };

  // ── SmartDesk save edit ──
  const sdSaveEdit = async () => {
    if (!sdEditContent.trim()) {
      setSdEditingId(null);
      return;
    }
    const idx = sdConv.findIndex((m) => m.id === sdEditingId);
    if (idx === -1) {
      setSdEditingId(null);
      return;
    }
    const updated = sdConv.slice(0, idx);
    updated.push({
      ...sdConv[idx],
      content: sdEditContent.trim(),
      edited: true,
    });
    setSdConv(updated);
    setSdEditingId(null);
    setSdEditContent("");
    setSdLoading(true);
    try {
      const res = await aiSmartDesk(sdEditContent.trim(), "");
      const reply =
        res.data?.data?.response ||
        res.data?.response ||
        "Here is my revised response.";
      setSdConv((prev) => [
        ...prev,
        { id: sdGenId(), type: "ai", content: reply, ts: new Date() },
      ]);
    } catch (e) {
      setSdConv((prev) => [
        ...prev,
        {
          id: sdGenId(),
          type: "ai",
          content: "Error: " + e.message,
          ts: new Date(),
        },
      ]);
    }
    setSdLoading(false);
  };

  const token = sessionStorage.getItem("token");

  const getUserIdentity = () => {
    const token =
      sessionStorage.getItem("token") || localStorage.getItem("token");

    if (!token) return null;

    try {
      const decoded = jwtDecode(token);

      if (decoded.role === "guest") {
        return { machineId: decoded.machineId };
      }

      return { userId: decoded._id };
    } catch (err) {
      console.error("Invalid token");
      return null;
    }
  };

  useEffect(() => {
    document.body.style.margin = "0";
    document.body.style.padding = "0";
    return () => {};
  }, []);

  useEffect(() => {
    if (accessToCitationScreen == false) {
      setSubReqOpen(true);
    }
  }, [accessToCitationScreen]);

  const [formData, setFormData] = useState({
    title: "",
    description: "",
    websiteName: "",
    url: "",
    contributors: [
      {
        firstName: "",
        lastName: "",
        middleName: "",
        suffix: "",
        position: "Author",
      },
    ],
    publicationDate: { year: "", month: "", day: "" },
    accessDate: { year: "", month: "", day: "" },
  });

  const showToast = (message, type = "info") => {
    setToast({ message, type });
  };

  // Function to handle view source navigation
  const handleViewSource = (url) => {
    if (url && url !== "N/A") {
      // Ensure URL has proper protocol
      let formattedUrl = url;
      if (!/^https?:\/\//i.test(url)) {
        formattedUrl = "https://" + url;
      }

      // Open URL in new tab
      window.open(formattedUrl, "_blank", "noopener,noreferrer");
    } else {
      showToast("No URL available for this citation", "warning");
    }
  };

  // SweetAlert Delete Confirmation Function
  const permanentDeleteCitation = async (
    citation,
    isBulk = false,
    selectedCitations = [],
  ) => {
    swal({
      title: "Permanent Deletion",
      text: isBulk
        ? `Do you want to permanently delete ${selectedCitations.length} citation(s)?`
        : "Do you want to permanently delete this citation?",
      icon: "warning",
      buttons: true,
      dangerMode: true,
    }).then(async (permanentDelete) => {
      if (permanentDelete) {
        setLoading(true);
        try {
          let response;
          if (isBulk) {
            const selectedIds = selectedCitations.map(
              (citation) => citation._id,
            );
            response =
              await citationService.deleteSelectedCitations(selectedIds);
          } else {
            response = await citationService.deleteCitation(citation._id);
          }

          console.log("Backend Response:", response);
          if (response.status === 200) {
            showToast(
              isBulk
                ? "Citations deleted successfully"
                : "Citation deleted successfully",
              "success",
            );
            fetchCitationDetails();

            const data = {
              userId: sessionStorage.getItem("userId"),
              organizationId: sessionStorage.getItem("organizationId"),
              actionType: "deleteCitation",
            };

            const addLogs = await addUserLogs(data);
            if (addLogs.status !== 200) {
              showToast(addLogs.message, "error");
            }
          } else {
            showToast(
              isBulk
                ? "Citations deletion failed!"
                : "Citation deletion failed!",
              "error",
            );
          }
        } catch (error) {
          console.error("Error calling backend API:", error.message);
          showToast(
            isBulk ? "Error deleting citations" : "Error deleting citation",
            "error",
          );
        } finally {
          setLoading(false);
        }
      } else {
        swal(isBulk ? "Your citations are safe!" : "Your citation is safe!");
      }
    });
  };

  const fetchCitationDetails = async () => {
    try {
      const email = sessionStorage.getItem("currentUserEmail");
      let data = { email };
      const response = await citationService.getCitationDetails(data);
      if (response.status === 200) {
        const reversedCitations = response.citationDetails.reverse();

        // Clean the citations by removing HTML tags
        const cleanedCitations = reversedCitations.map((citation) =>
          cleanCitationData(citation),
        );

        setInitialCitations(cleanedCitations);
        setTotalSource(cleanedCitations.length);
        setTotalSearchedSource(cleanedCitations.length);
        const citationsWithCheckState = cleanedCitations.map((citation) => ({
          ...citation,
          isChecked: false,
        }));
        setCitations(citationsWithCheckState);
        setDisplayByDate(false);
      } else {
        console.error("Error fetching citation details:", response.message);
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
    }
  };

  useEffect(() => {
    fetchCitationDetails();
  }, []);

  const handleTabChange = (event, newValue) => {
    setSelectedTab(newValue);
    setSearchInput("");
    setWebsiteData(null);
  };

  const handleSelectAll = (event) => {
    const isChecked = event.target.checked;
    setSelectAll(isChecked);
    setCitations(citations.map((c) => ({ ...c, isChecked })));
  };

  const handleCardCheck = (id) => {
    const updatedCitations = citations.map((c) =>
      c._id === id ? { ...c, isChecked: !c.isChecked } : c,
    );
    setCitations(updatedCitations);

    const allChecked =
      updatedCitations.length > 0 && updatedCitations.every((c) => c.isChecked);
    const someChecked = updatedCitations.some((c) => c.isChecked);

    if (allChecked) {
      setSelectAll(true);
    } else if (someChecked) {
      setSelectAll(false);
    } else {
      setSelectAll(false);
    }
  };

  const selectedCount = citations.filter((c) => c.isChecked).length;
  const totalCount = citations.length;

  const handleSearchChange = (e) => {
    const newSearchTerm = e.target.value.toLowerCase();
    setSearchTerm(newSearchTerm);
    const filteredCitations = initialCitations.filter((citation) =>
      citation.title.toLowerCase().includes(newSearchTerm),
    );
    setCitations(newSearchTerm ? filteredCitations : initialCitations);
    setTotalSearchedSource(
      newSearchTerm ? filteredCitations.length : initialCitations.length,
    );
  };

  const handleSortClick = () => {
    const newSortOrder = sortOrder === "asc" ? "desc" : "asc";
    setSortOrder(newSortOrder);
    const sortedCitations = [...citations].sort((a, b) => {
      const titleA = a.title.toUpperCase();
      const titleB = b.title.toUpperCase();
      return newSortOrder === "asc"
        ? titleA.localeCompare(titleB)
        : titleB.localeCompare(titleA);
    });
    setCitations(sortedCitations);
    setInitialCitations(sortedCitations);
  };

  const handleCitationStyleChange = (event) => {
    setCitationStyle(event.target.value);
  };

  const handleCopySelected = () => {
    const selectedCitations = citations.filter((c) => c.isChecked);
    if (selectedCitations.length === 0) {
      showToast("Select citations to copy", "warning");
      return;
    }
    const copiedText = selectedCitations
      .map(
        (c) =>
          `Title: ${c.title}\nFull Citation: ${c.fullCitation}\nIn-Text Citation: ${c.publicationDate.year}\nCitation Style: ${c.textStyle}\n\n`,
      )
      .join("");
    navigator.clipboard.writeText(copiedText);
    showToast("Citations copied to clipboard!", "success");
  };

  // Updated handleDeleteSelected with SweetAlert
  const handleDeleteSelected = async () => {
    const selectedCitations = citations.filter(
      (citation) => citation.isChecked,
    );
    if (selectedCitations.length === 0) {
      showToast("Select citations to delete", "warning");
      return;
    }

    permanentDeleteCitation(null, true, selectedCitations);
  };

  // Updated handleDeleteCitation with SweetAlert
  const handleDeleteCitation = async (id) => {
    const citation = citations.find((c) => c._id === id);
    if (citation) {
      permanentDeleteCitation(citation, false);
    }
  };

  const handleCopyCitation = (citation) => {
    const text = `Title: ${citation.title}\nFull Citation: ${citation.fullCitation}\nIn-Text Citation: ${citation.publicationDate.year}\nCitation Style: ${citation.textStyle}`;
    navigator.clipboard.writeText(text);
    showToast("Text copied", "success");
  };

  const handleGroupBy = (type) => {
    setGroupByAnchor(null);

    if (type === "No Group") {
      setCitations(initialCitations);
      setDisplayByDate(false);
    } else if (type === "Source Type") {
      const groupedCitations = {};
      initialCitations.forEach((citation) => {
        const sourceType = citation.sourceType || "Unknown";
        if (!groupedCitations[sourceType]) {
          groupedCitations[sourceType] = [];
        }
        groupedCitations[sourceType].push(citation);
      });

      const sortedCitations = Object.values(groupedCitations).flat();
      setCitations(sortedCitations);
      setDisplayByDate(false);
    } else if (type === "Published Year") {
      setDisplayByDate(true);
    }
  };

  const handleDownload = async (format) => {
    setDownloadAnchor(null);
    const selectedCitations = citations.filter((c) => c.isChecked);
    if (selectedCitations.length === 0) {
      showToast("Select citations to download", "warning");
      return;
    }

    try {
      switch (format) {
        case "MS-Word":
          const wordContent = selectedCitations
            .map(
              (citation, index) =>
                `Citation ${index + 1}:\n` +
                `Title: ${citation.title}\n` +
                `Full Citation: ${citation.fullCitation}\n` +
                `In-Text Citation: ${citation.publicationDate.year}\n` +
                `Citation Style: ${citation.textStyle}\n` +
                `Source Type: ${citation.sourceType}\n` +
                `URL: ${citation.url || "N/A"}\n` +
                `Description: ${citation.description || "N/A"}\n` +
                `---\n`,
            )
            .join("\n");

          downloadFile(wordContent, "citations.doc", "application/msword");
          break;

        // case "BibTeX":
        //   const bibtexContent = selectedCitations
        //     .map((citation, index) =>
        //       `@article{citation${index + 1},\n` +
        //       `  title = {${citation.title}},\n` +
        //       `  author = {${citation.contributors?.[0]?.firstName || 'Unknown'} ${citation.contributors?.[0]?.lastName || 'Author'}},\n` +
        //       `  year = {${citation.publicationDate.year}},\n` +
        //       `  journal = {${citation.sourceType}},\n` +
        //       `  url = {${citation.url || ''}}\n` +
        //       `}`
        //     )
        //     .join("\n\n");

        //   downloadFile(bibtexContent, "citations.bib", "application/x-bibtex");
        //   break;

        case "PDF":
          await generatePDF(selectedCitations);
          break;

        default:
          showToast("Unsupported format", "error");
          return;
      }

      showToast(
        `Downloaded ${selectedCitations.length} citations as ${format}`,
        "success",
      );
    } catch (error) {
      console.error("Download error:", error);
      showToast("Error downloading file", "error");
    }
  };

  const downloadFile = (content, filename, mimeType) => {
    const blob = new Blob([content], { type: mimeType });
    const url = URL.createObjectURL(blob);
    const link = document.createElement("a");
    link.href = url;
    link.download = filename;
    link.style.display = "none";

    document.body.appendChild(link);
    link.click();
    document.body.removeChild(link);

    setTimeout(() => URL.revokeObjectURL(url), 100);
  };

  const generatePDF = (selectedCitations) => {
    return new Promise((resolve) => {
      const pdf = new jsPDF();
      let yPosition = 20;
      const lineHeight = 7;
      const pageHeight = pdf.internal.pageSize.height;
      const margin = 20;
      const maxWidth = 170;

      pdf.setFontSize(16);
      pdf.setFont(undefined, "bold");
      pdf.text("CITATIONS EXPORT", margin, yPosition);
      yPosition += lineHeight * 2;

      pdf.setFontSize(10);
      pdf.setFont(undefined, "normal");
      pdf.text(
        `Generated on: ${new Date().toLocaleDateString()}`,
        margin,
        yPosition,
      );
      yPosition += lineHeight;
      pdf.text(
        `Total Citations: ${selectedCitations.length}`,
        margin,
        yPosition,
      );
      yPosition += lineHeight;
      pdf.text(`Citation Style: ${citationStyle}`, margin, yPosition);
      yPosition += lineHeight * 2;

      selectedCitations.forEach((citation, index) => {
        if (yPosition > pageHeight - 60) {
          pdf.addPage();
          yPosition = margin;
        }

        pdf.setFontSize(12);
        pdf.setFont(undefined, "bold");
        pdf.text(`Citation ${index + 1}:`, margin, yPosition);
        yPosition += lineHeight;

        pdf.setFontSize(10);
        pdf.setFont(undefined, "normal");

        const addWrappedText = (text, isBold = false) => {
          if (isBold) {
            pdf.setFont(undefined, "bold");
          }

          const lines = pdf.splitTextToSize(text, maxWidth);
          lines.forEach((line) => {
            if (yPosition > pageHeight - 20) {
              pdf.addPage();
              yPosition = margin;
            }
            pdf.text(line, margin, yPosition);
            yPosition += lineHeight;
          });

          if (isBold) {
            pdf.setFont(undefined, "normal");
          }
        };

        addWrappedText(`Title: ${citation.title}`);
        addWrappedText(`Full Citation: ${citation.fullCitation}`);
        addWrappedText(`In-Text Citation: ${citation.publicationDate.year}`);
        addWrappedText(`Citation Style: ${citation.textStyle}`);
        addWrappedText(`Source Type: ${citation.sourceType}`);
        addWrappedText(`URL: ${citation.url || "N/A"}`);

        if (citation.description) {
          addWrappedText(`Description: ${citation.description}`);
        }

        if (citation.contributors && citation.contributors.length > 0) {
          const contributors = citation.contributors
            .map((c) => `${c.firstName} ${c.lastName}`)
            .join(", ");
          addWrappedText(`Contributors: ${contributors}`);
        }

        yPosition += lineHeight;
      });

      pdf.save("citations.pdf");
      resolve();
    });
  };

  const handleCardMenu = (event, id) => {
    setCardMenuAnchor(event.currentTarget);
    setSelectedCardId(id);
  };

  const handleCloseCardMenu = () => {
    setCardMenuAnchor(null);
    setSelectedCardId(null);
  };

  const isValidURL = (url) => {
    try {
      if (!/^https?:\/\//i.test(url)) {
        url = "https://" + url;
      }
      const parsedUrl = new URL(url);
      const hostname = parsedUrl.hostname;
      const validUrlPattern = new RegExp(
        "\\.(com|io|org|net|gov|edu|co)$",
        "i",
      );
      return validUrlPattern.test(hostname);
    } catch (e) {
      return false;
    }
  };

  const validateInput = (selectedValue, searchInput) => {
    if (selectedValue === 0 && !isValidURL(searchInput)) {
      showToast("Please enter a valid URL", "warning");
      return false;
    }
    return true;
  };

  // const handleCiteButton = async () => {
  //   let suggestionArray = [];
  //   const identity = getUserIdentity();
  //   const limitKey = identity.userId || identity.machineId;
  //   const checkailimit = await checkAIRequestLimit(limitKey);
  //   console.log(checkailimit, "_checkailimit");
  //   if (checkailimit == false) {
  //     showToast("AI request limit reached.", "warning");
  //     return;
  //   }
  //   if (!searchInput.trim()) {
  //     showToast("Search bar is empty", "warning");
  //     return;
  //   }
  //   let sourceitem = "";
  //   if (selectedTab === 0) {
  //     sourceitem = "Webpage";
  //   } else if (selectedTab === 1) {
  //     sourceitem = "Journal Article";
  //   } else {
  //     sourceitem = "Book";
  //   }
  //   if (validateInput(selectedTab, searchInput)) {
  //     setLoading(true);
  //     try {
  //       let response;
  //       const identity = getUserIdentity();
  //       let isCoAuthor = false;

  //       if (sourceitem === "Webpage") {
  //         response = await citationService.getCheckCitationWebpage(
  //           searchInput,
  //           citationStyle,
  //           sourceitem,
  //           // userId,
  //           isCoAuthor,
  //           ...identity,
  //         );

  //         if (response.status === 200) {
  //           setLoading(false);
  //           console.log("Backend Response:", response);
  //           let responseOutput = response?.data?.output;
  //           const parsedData = JSON.parse(responseOutput[0]);
  //           suggestionArray = parsedData.replacements?.corrections;
  //           console.log("changedJSon_", suggestionArray, parsedData);

  //           // Clean the website data by removing HTML tags
  //           const cleanedWebsiteData = suggestionArray.map((item) =>
  //             cleanCitationData(item),
  //           );
  //           setWebsiteData(cleanedWebsiteData);
  //         }
  //       } else if (sourceitem === "Journal Article") {
  //         response = await citationService.getCheckCitationJournalArticle(
  //           searchInput,
  //           citationStyle,
  //           sourceitem,
  //           // userId,
  //           isCoAuthor,
  //           ...identity,
  //         );

  //         if (response.status === 200) {
  //           setLoading(false);
  //           console.log("Backend Response:", response);
  //           let responseOutput = response?.data?.output;
  //           const parsedData = JSON.parse(responseOutput[0]);
  //           suggestionArray = parsedData.replacements?.corrections;
  //           console.log("changedJSon_", suggestionArray, parsedData);

  //           // Clean the website data by removing HTML tags
  //           const cleanedWebsiteData = suggestionArray.map((item) =>
  //             cleanCitationData(item),
  //           );
  //           setWebsiteData(cleanedWebsiteData);
  //         }
  //       } else {
  //         response = await citationService.getCheckCitationBook(
  //           searchInput,
  //           citationStyle,
  //           sourceitem,
  //           // userId,
  //           isCoAuthor,
  //           ...identity,
  //         );

  //         if (response.status === 200) {
  //           setLoading(false);
  //           console.log("Backend Response:", response);
  //           let responseOutput = response?.data?.output;
  //           const parsedData = JSON.parse(responseOutput[0]);
  //           suggestionArray = parsedData.replacements?.corrections;
  //           console.log("changedJSon_", suggestionArray, parsedData);

  //           // Clean the website data by removing HTML tags
  //           const cleanedWebsiteData = suggestionArray.map((item) =>
  //             cleanCitationData(item),
  //           );
  //           setWebsiteData(cleanedWebsiteData);
  //         }
  //       }
  //     } catch (error) {
  //       setLoading(false);
  //       showToast("Error fetching citation details", "error");
  //       console.error("Error calling backend API:", error.message);
  //     }
  //   }
  // };

  const handleCiteButton = async () => {
    let suggestionArray = [];

    const identity = getUserIdentity();
    const limitKey = identity?.userId || identity?.machineId;

    // const checkailimit = await checkAIRequestLimit(limitKey);

    // if (checkailimit === false) {
    //   showToast("AI request limit reached.", "warning");
    //   return;
    // }

    if (!searchInput.trim()) {
      showToast("Search bar is empty", "warning");
      return;
    }

    let sourceitem = "";
    if (selectedTab === 0) {
      sourceitem = "Webpage";
    } else if (selectedTab === 1) {
      sourceitem = "Journal Article";
    } else {
      sourceitem = "Book";
    }

    if (!validateInput(selectedTab, searchInput)) return;

    setLoading(true);

    try {
      let response;
      let isCoAuthor = false;

      // ✅ FIX: Create ONE payload object
      const payload = {
        text: searchInput,
        citationStyle,
        sourceItem: sourceitem,
        isCoAuthor,
        ...identity, // automatically adds userId OR machineId
      };

      if (sourceitem === "Webpage") {
        response = await citationService.getCheckCitationWebpage(payload);
      } else if (sourceitem === "Journal Article") {
        response =
          await citationService.getCheckCitationJournalArticle(payload);
      } else {
        response = await citationService.getCheckCitationBook(payload);
      }

      if (response?.status === 200) {
        let responseOutput = response?.data?.output;

        if (!responseOutput || !responseOutput[0]) {
          throw new Error("Invalid response format");
        }

        const parsedData = JSON.parse(responseOutput[0].trim());
        suggestionArray = parsedData?.replacements?.corrections || [];

        const cleanedWebsiteData = suggestionArray.map((item) =>
          cleanCitationData(item),
        );

        setWebsiteData(cleanedWebsiteData);
      } else {
        throw new Error("API returned non-200 status");
      }
    } catch (error) {
      console.error("Error calling backend API:", error);
      showToast("Error fetching citation details", "error");
    } finally {
      setLoading(false);
    }
  };

  const handleSaveCitation = async () => {
    const identity = getUserIdentity();
    if (!identity) {
      showToast("User identity not found", "error");
      return;
    }
    const email = sessionStorage.getItem("currentUserEmail");
    try {
      // Clean the citation data before saving
      const cleanedCitationData = cleanCitationData(websiteData[0]);

      const response = await citationService.getAddCitation2(
        {
          ...cleanedCitationData,
          ...identity,
        },
        email,
      );
      console.log("Backend Response:", response);
      if (response.status == 200) {
        showToast("Citation saved successfully", "success");
        fetchCitationDetails();
        setWebsiteData(null);
        const data = {
          // userId: sessionStorage.getItem("userId"),
          // organizationId: sessionStorage.getItem("organizationId"),
          ...identity,
          actionType: "addCitation",
        };
        const addLogs = await addUserLogs(data);
        if (addLogs.status !== 200) {
          showToast(addLogs.message, "error");
        }
      }
    } catch (error) {
      console.error("Error calling backend API:", error.message);
      showToast("Error saving citation", "error");
    }
  };

  const handleOpenManualModal = () => {
    console.log("Access to Cite Manually:", accessToCiteManually);
    if (accessToCiteManually == false) {
      setSubReqOpen(true);
      setIsFeatureInside(true);
      return;
    }
    setFormData({
      title: "",
      description: "",
      websiteName: "",
      url: "",
      contributors: [
        {
          firstName: "",
          lastName: "",
          middleName: "",
          suffix: "",
          position: "Author",
        },
      ],
      publicationDate: { year: "", month: "", day: "" },
      accessDate: { year: "", month: "", day: "" },
    });
    setShowManualModal(true);

  };

  const handleCloseManualModal = () => {
    setShowManualModal(false);
  };

  const handleSaveManualCitation = () => {
    if (!formData.title.trim()) {
      showToast("Please provide citation title.", "error");
      return;
    }

    const newCitation = {
      _id: Date.now().toString(),
      title: formData.title,
      fullCitation: `${formData.contributors[0].lastName}, ${formData.contributors[0].firstName}. (${formData.publicationDate.year}). ${formData.title}.`,
      publicationDate: formData.publicationDate,
      textStyle: citationStyle,
      sourceType:
        selectedTab === 0
          ? "Webpage"
          : selectedTab === 1
            ? "Journal Article"
            : "Book",
      isChecked: false,
      contributors: formData.contributors,
      url: formData.url,
      description: formData.description,
      websiteName: formData.websiteName,
    };

    // Clean the citation data before adding to state
    const cleanedCitation = cleanCitationData(newCitation);

    const updatedCitations = [cleanedCitation, ...citations];
    setCitations(updatedCitations);
    setInitialCitations(updatedCitations);
    setTotalSource(updatedCitations.length);
    setTotalSearchedSource(updatedCitations.length);
    showToast("Citation saved successfully", "success");
    handleCloseManualModal();
  };

  const handleBreadcrumbClick = (event, path) => {
    event.preventDefault();
    window.location.href = "/docTags";
    // history.push(path);
  };

  const handleOpenEditModal = (citation) => {
    setEditingCitation(citation);
    setFormData({
      title: citation.title,
      description: citation.description || "",
      websiteName: citation.websiteName || "",
      url: citation.url || "",
      contributors: citation.contributors || [
        {
          firstName: "",
          lastName: "",
          middleName: "",
          suffix: "",
          position: "Author",
        },
      ],
      publicationDate: citation.publicationDate,
      accessDate: citation.accessDate || { year: "", month: "", day: "" },
    });
    setShowEditModal(true);
    handleCloseCardMenu();
  };

  const handleCloseEditModal = () => {
    setShowEditModal(false);
    setEditingCitation(null);
  };

  const handleSaveEditCitation = () => {
    if (!formData.title.trim()) {
      showToast("Please provide citation title.", "error");
      return;
    }

    const updatedCitations = citations.map((c) => {
      if (c._id === editingCitation._id) {
        const updatedCitation = {
          ...c,
          title: formData.title,
          fullCitation: `${formData.contributors[0].lastName}, ${formData.contributors[0].firstName}. (${formData.publicationDate.year}). ${formData.title}.`,
          publicationDate: formData.publicationDate,
          contributors: formData.contributors,
          url: formData.url,
          description: formData.description,
          websiteName: formData.websiteName,
        };

        // Clean the citation data before updating
        return cleanCitationData(updatedCitation);
      }
      return c;
    });

    setCitations(updatedCitations);
    setInitialCitations(updatedCitations);
    showToast("Citation updated successfully", "success");
    handleCloseEditModal();
  };

  const handleAddContributor = () => {
    setFormData({
      ...formData,
      contributors: [
        ...formData.contributors,
        {
          firstName: "",
          lastName: "",
          middleName: "",
          suffix: "",
          position: "Author",
        },
      ],
    });
  };

  const handleRemoveContributor = (index) => {
    const newContributors = formData.contributors.filter((_, i) => i !== index);
    setFormData({ ...formData, contributors: newContributors });
  };

  const handleUpdateContributor = (index, field, value) => {
    const newContributors = [...formData.contributors];
    newContributors[index][field] = value;
    setFormData({ ...formData, contributors: newContributors });
  };

  const getTabIcon = (index) => {
    switch (index) {
      case 0:
        return <Language sx={{ mr: 1 }} />;
      case 1:
        return <Description sx={{ mr: 1 }} />;
      case 2:
        return <MenuBook sx={{ mr: 1 }} />;
      default:
        return null;
    }
  };

  const getSourceIcon = (sourceType) => {
    switch (sourceType) {
      case "Book":
        return <MenuBook />;
      case "Journal Article":
        return <Description />;
      default:
        return <Language />;
    }
  };

  const yearsArray = [
    ...new Set(
      initialCitations.map((citation) => citation.publicationDate.year),
    ),
  ];

  const filteredCitationsByYear = useMemo(() => {
    const sortedYearsArray = [...yearsArray].sort((a, b) => a - b);

    return sortedYearsArray.map((year) => ({
      year,
      citations: citations.filter((cit) => cit.publicationDate.year === year),
    }));
  }, [citations, yearsArray]);

  const tabs = ["Webpage", "Journal Article", "Book"];

  return (
    <>
      <SubscriptionRequired
        open={subReqOpen}
        setOpen={setSubReqOpen}
        isFeatureInside={isFeatureInside}
        setIsFeatureInside={setIsFeatureInside}
        path={"citation"}
      />
      <Loader loading={loading} />
      <Box
        sx={{
          position: "fixed",
          inset: 0,
          zIndex: 1,
          overflowY: "auto",
          overflowX: "hidden",
          bgcolor: "#f5f7fa",
          py: 4,
        }}
      >
        {toast && (
          <Toast
            message={toast.message}
            type={toast.type}
            onClose={() => setToast(null)}
          />
        )}

        <Container maxWidth={false} disableGutters sx={{ px: 3 }}>
          <Box sx={{ mb: 3 }}>
            <Paper
              elevation={1}
              sx={{
                p: 2.5,
                bgcolor: "white",
                borderRadius: 3,
                border: "1px solid",
                borderColor: "divider",
                transition: "all 0.3s ease",
                "&:hover": {
                  boxShadow: "0 4px 12px rgba(102, 126, 234, 0.15)",
                },
              }}
            >
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  px: 1,
                  textShadow: "0 0 10px rgba(192,144,255,0.6)",
                }}
              >
                <Box
                  sx={{
                    bgcolor: "white",
                    borderRadius: 2,
                    display: "flex",
                    alignItems: "center",
                    justifyContent: "center",
                    width: 32,
                    height: 32,
                    mr: 2,
                    boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  }}
                >
                  <img
                    alt="logo"
                    src={Poetlogopen}
                    style={{
                      height: "28px",
                      width: "28px",
                      objectFit: "contain",
                      bgcolor: "white",
                      // filter: "drop-shadow(0 0 7px rgba(93, 0, 255, 0.65))",
                      filter: "drop-shadow(0 0 7px rgba(163, 163, 164, 0.65))",
                    }}
                  />
                </Box>

                <Breadcrumbs
                  separator={
                    <NavigateNextIcon
                      fontSize="small"
                      sx={{ color: "#667eea" }}
                    />
                  }
                  aria-label="breadcrumb"
                  sx={{
                    display: "flex",
                    alignItems: "center",
                    flexWrap: "nowrap",
                  }}
                >
                  <Box
                    sx={{
                      display: "flex",
                      alignItems: "center",
                      flexWrap: "nowrap",
                      gap: 1,
                    }}
                  >
                    <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />
                    <Link
                      to="/docTags"
                      onClick={(e) => handleBreadcrumbClick(e, "/docTags")}
                      style={{
                        textDecoration: "none",
                        color: "#667eea",
                        fontWeight: 500,
                        fontSize: "0.95rem",
                        padding: "4px 8px",
                        borderRadius: "6px",
                        transition: "all 0.2s ease",
                        whiteSpace: "nowrap",
                      }}
                      onMouseEnter={(e) => {
                        e.currentTarget.style.backgroundColor =
                          "rgba(102, 126, 234, 0.08)";
                        e.currentTarget.style.color = "#764ba2";
                      }}
                      onMouseLeave={(e) => {
                        e.currentTarget.style.backgroundColor = "transparent";
                        e.currentTarget.style.color = "#667eea";
                      }}
                    >
                      MultiTool AI
                    </Link>
                    <NavigateNextIcon
                      fontSize="small"
                      sx={{ color: "#667eea", mx: 0.5 }}
                    />
                    <Typography
                      sx={{
                        color: "#1a1a1a",
                        fontWeight: 600,
                        fontSize: "0.95rem",
                        padding: "4px 8px",
                        borderRadius: "6px",
                        backgroundColor: "rgba(102, 126, 234, 0.08)",
                        whiteSpace: "nowrap",
                        display: "flex",
                        alignItems: "center",
                        gap: 0.5,
                      }}
                    >
                      <AutoFixHigh sx={{ fontSize: 20, color: "#667eea" }} />
                      AI Citation Generator
                    </Typography>
                  </Box>
                </Breadcrumbs>
              </Box>
            </Paper>
          </Box>
          {/* Header Section */}
          <Paper
            elevation={0}
            sx={{
              p: 2,
              mb: 3,
              borderRadius: 3,
              background: "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
              color: "white",
              boxShadow: "0 4px 20px rgba(102, 126, 234, 0.4)",
            }}
          >
            <div style={{ display: "flex", justifyContent: "space-between" }}>
              <div>
                <Typography variant="h4" fontWeight="700" gutterBottom>
                  AI Citation Generator
                </Typography>
                <Typography variant="subtitle1" sx={{ opacity: 0.9 }}>
                  Generate accurate citations in multiple formats
                </Typography>
              </div>
              {/* <div>
                <Link to="/docTags">
                  <Button
                    variant="contained"
                    sx={{
                      right: 0,
                      top: "20%",
                      whiteSpace: "nowrap",
                      minWidth: "auto",
                      px: 2,
                      fontWeight: 700,
                      backgroundColor: "#ffffff",
                      color: "#1976d2",
                      "&:hover": {
                        backgroundColor: "#f5f5f5",
                      },
                    }}
                  >
                    ← Back
                  </Button>
                </Link>
              </div> */}
            </div>
          </Paper>

          {/* Search Section */}
          <Paper elevation={0} sx={{ p: 3, mb: 3, borderRadius: 3 }}>
            {/* Tabs */}
            <Tabs
              value={selectedTab}
              onChange={handleTabChange}
              sx={{
                mb: 3,
                borderBottom: 1,
                borderColor: "divider",
                "& .MuiTab-root": {
                  fontWeight: 600,
                  fontSize: "0.95rem",
                  textTransform: "none",
                  minHeight: 48,
                },
              }}
            >
              {tabs.map((tab, index) => (
                <Tab
                  key={tab}
                  icon={getTabIcon(index)}
                  iconPosition="start"
                  label={tab}
                />
              ))}
            </Tabs>

            {/* Search Input */}
            <Grid2 container spacing={2}>
              <Grid2 xs={12} md={8} lg={8}>
                <TextField
                  fullWidth
                  placeholder={
                    selectedTab === 0
                      ? "Enter or paste the URL"
                      : selectedTab === 1
                        ? "Search or paste article title, DOI, or URL"
                        : "Search or paste book title, ISBN, or URL"
                  }
                  value={searchInput}
                  onChange={(e) => setSearchInput(e.target.value)}
                  InputProps={{
                    startAdornment: (
                      <InputAdornment position="start">
                        <LinkIcon color="action" />
                      </InputAdornment>
                    ),
                  }}
                  sx={{
                    "& .MuiOutlinedInput-root": {
                      borderRadius: 2,
                    },
                  }}
                />
              </Grid2>
              <Grid2 xs={12} md={2} lg={2}>
                <Button
                  fullWidth
                  variant="contained"
                  size="large"
                  onClick={handleCiteButton}
                  sx={{
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 600,
                    height: "56px",
                    background:
                      "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                    "&:hover": {
                      background:
                        "linear-gradient(135deg, #5568d3 0%, #653a8b 100%)",
                    },
                  }}
                >
                  Cite
                </Button>
              </Grid2>
              <Grid2 xs={12} md={2} lg={2}>
                <Button
                  fullWidth
                  variant="outlined"
                  startIcon={<Add />}
                  size="large"
                  onClick={handleOpenManualModal}
                  sx={{
                    borderRadius: 2,
                    textTransform: "none",
                    fontWeight: 600,
                    height: "56px",
                    borderWidth: 2,
                    "&:hover": {
                      borderWidth: 2,
                    },
                  }}
                >
                  Cite Manually
                </Button>
              </Grid2>
            </Grid2>

            {/* Citation Preview Accordion */}
            {websiteData && (
              <Accordion
                sx={{
                  borderRadius: 2,
                  mt: 1,
                  bgcolor: "white",
                  boxShadow: "0 2px 8px rgba(0,0,0,0.1)",
                  "&:before": {
                    display: "none",
                  },
                }}
              >
                <AccordionSummary
                  expandIcon={<ExpandMore />}
                  sx={{
                    bgcolor: "primary.main",
                    color: "white",
                    borderRadius: "8px 8px 0 0",
                    "&.Mui-expanded": {
                      bgcolor: "primary.main",
                      borderRadius: "8px 8px 0 0",
                    },
                  }}
                >
                  <Typography fontWeight="600">
                    {websiteData[0].title}
                  </Typography>
                </AccordionSummary>
                <AccordionDetails sx={{ bgcolor: "white" }}>
                  <Typography
                    variant="body2"
                    color="text.secondary"
                    gutterBottom
                  >
                    {websiteData[0].sourceType} |{" "}
                    {websiteData[0].publicationDate.year}
                  </Typography>
                  <Box sx={{ display: "flex", gap: 1, mt: 2 }}>
                    <LightTooltip title="Save Citation">
                      <IconButton color="success" onClick={handleSaveCitation}>
                        <AssignmentTurnedIn />
                      </IconButton>
                    </LightTooltip>
                    <LightTooltip title="Copy">
                      <IconButton
                        color="primary"
                        onClick={() => {
                          const text = `${websiteData[0].title} - ${
                            websiteData[0].description
                          }\n${websiteData[0].sourceType} | ${
                            websiteData[0].publicationDate.year
                          }\n${websiteData[0].url || "No URL available"}`;
                          navigator.clipboard.writeText(text);
                          showToast("Text copied", "success");
                        }}
                      >
                        <ContentCopyIcon />
                      </IconButton>
                    </LightTooltip>
                    {websiteData[0].url && (
                      <LightTooltip title="View Source">
                        <IconButton
                          color="info"
                          onClick={() => handleViewSource(websiteData[0].url)}
                        >
                          <OpenInNew />
                        </IconButton>
                      </LightTooltip>
                    )}
                    <LightTooltip title="Close">
                      <IconButton
                        color="error"
                        onClick={() => setWebsiteData(null)}
                      >
                        <Close />
                      </IconButton>
                    </LightTooltip>
                  </Box>
                </AccordionDetails>
              </Accordion>
            )}
          </Paper>

          {/* Citations Section */}
          <Paper elevation={0} sx={{ p: 3, borderRadius: 3 }}>
            {/* Toolbar */}
            <Box sx={{ mb: 2 }}>
              <Grid2 container spacing={2} sx={{ mb: 2 }}>
                <Grid2 xs={12} md={3} lg={3}>
                  <Box sx={{ display: "flex", alignItems: "center", gap: 2 }}>
                    <Typography variant="h5" fontWeight="700">
                      Citations
                    </Typography>
                    <Badge
                      badgeContent={totalCount}
                      color="primary"
                      sx={{
                        "& .MuiBadge-badge": {
                          fontSize: "0.85rem",
                          height: "24px",
                          minWidth: "24px",
                        },
                      }}
                    >
                      <Avatar
                        sx={{ width: 32, height: 32, bgcolor: "primary.main" }}
                      >
                        <Description sx={{ fontSize: 18 }} />
                      </Avatar>
                    </Badge>
                  </Box>
                </Grid2>
                <Grid2 xs={12} md={9} lg={9}>
                  <Box
                    sx={{
                      display: "flex",
                      gap: 2,
                      justifyContent: "flex-end",
                      flexWrap: "wrap",
                    }}
                  >
                    <TextField
                      size="small"
                      placeholder="Search citations..."
                      value={searchTerm}
                      onChange={handleSearchChange}
                      InputProps={{
                        startAdornment: (
                          <InputAdornment position="start">
                            <Search fontSize="small" />
                          </InputAdornment>
                        ),
                      }}
                      sx={{
                        minWidth: 250,
                        "& .MuiOutlinedInput-root": {
                          borderRadius: 2,
                        },
                      }}
                    />
                    <FormControl size="small" sx={{ minWidth: 200 }}>
                      <Select
                        value={citationStyle}
                        onChange={handleCitationStyleChange}
                        sx={{ borderRadius: 2 }}
                      >
                        {citationStyles.map((style) => (
                          <MenuItem key={style} value={style}>
                            {style}
                          </MenuItem>
                        ))}
                      </Select>
                    </FormControl>
                    <LightTooltip title="Delete selected">
                      <IconButton
                        onClick={handleDeleteSelected}
                        sx={{
                          border: "2px solid",
                          borderColor: "error.main",
                          color: "error.main",
                          borderRadius: 2,
                          "&:hover": {
                            bgcolor: "error.light",
                            color: "white",
                          },
                        }}
                      >
                        <Delete />
                      </IconButton>
                    </LightTooltip>
                    <LightTooltip title="Copy selected">
                      <IconButton
                        onClick={handleCopySelected}
                        sx={{
                          border: "2px solid",
                          borderColor: "primary.main",
                          color: "primary.main",
                          borderRadius: 2,
                          "&:hover": {
                            bgcolor: "primary.light",
                            color: "white",
                          },
                        }}
                      >
                        <FileCopy />
                      </IconButton>
                    </LightTooltip>
                    <LightTooltip title="Download">
                      <IconButton
                        onClick={(e) => setDownloadAnchor(e.currentTarget)}
                        sx={{
                          border: "2px solid",
                          borderColor: "success.main",
                          color: "success.main",
                          borderRadius: 2,
                          "&:hover": {
                            bgcolor: "success.light",
                            color: "white",
                          },
                        }}
                      >
                        <GetApp />
                      </IconButton>
                    </LightTooltip>
                    <LightTooltip title="Sort">
                      <IconButton
                        onClick={handleSortClick}
                        sx={{
                          border: "2px solid",
                          borderColor: "warning.main",
                          color: "warning.main",
                          borderRadius: 2,
                          "&:hover": {
                            bgcolor: "warning.light",
                          },
                        }}
                      >
                        <Sort />
                      </IconButton>
                    </LightTooltip>
                    <LightTooltip title="Group by">
                      <IconButton
                        onClick={(e) => setGroupByAnchor(e.currentTarget)}
                        sx={{
                          border: "2px solid",
                          borderColor: "secondary.main",
                          color: "secondary.main",
                          borderRadius: 2,
                          "&:hover": {
                            bgcolor: "secondary.light",
                            color: "white",
                          },
                        }}
                      >
                        <ViewModule />
                      </IconButton>
                    </LightTooltip>
                  </Box>
                </Grid2>
              </Grid2>

              {/* Select All (Source Checkbox) */}
              <Box
                sx={{
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "space-between",
                }}
              >
                <FormControlLabel
                  control={
                    <Checkbox
                      checked={selectAll}
                      onChange={handleSelectAll}
                      indeterminate={
                        selectedCount > 0 && selectedCount < totalCount
                      }
                    />
                  }
                  label={
                    <Typography variant="body2" fontWeight={500}>
                      Source ({totalSearchedSource}{" "}
                      {totalSearchedSource !== totalSource
                        ? `out of ${totalSource}`
                        : ""}
                      )
                    </Typography>
                  }
                />
                {selectedCount > 0 && (
                  <Fade in={selectedCount > 0}>
                    <Chip
                      label={`${selectedCount} selected`}
                      color="primary"
                      onDelete={() => {
                        setSelectAll(false);
                        setCitations(
                          citations.map((c) => ({ ...c, isChecked: false })),
                        );
                      }}
                      sx={{ borderRadius: 2 }}
                    />
                  </Fade>
                )}
              </Box>
            </Box>

            <Divider sx={{ mb: 3 }} />

            {/* Citations Grid */}
            {displayByDate ? (
              filteredCitationsByYear.map(
                ({ year, citations: yearCitations }) => (
                  <Box key={year} sx={{ mb: 4 }}>
                    {yearCitations.length > 0 && (
                      <>
                        <Typography
                          variant="h6"
                          fontWeight="600"
                          sx={{ mb: 2 }}
                        >
                          {year}
                        </Typography>
                        <Grid2 container spacing={3}>
                          {yearCitations.map((citation) => (
                            <Grid2 xs={12} key={citation._id}>
                              <Card
                                elevation={0}
                                sx={{
                                  border: "2px solid",
                                  borderColor: citation.isChecked
                                    ? "primary.main"
                                    : "divider",
                                  borderRadius: 3,
                                  transition: "all 0.3s",
                                  "&:hover": {
                                    borderColor: "primary.main",
                                    transform: "translateY(-2px)",
                                    boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                                  },
                                }}
                              >
                                <CardContent>
                                  <Box
                                    sx={{
                                      display: "flex",
                                      alignItems: "flex-start",
                                      gap: 2,
                                    }}
                                  >
                                    <Checkbox
                                      checked={citation.isChecked || false}
                                      onChange={() =>
                                        handleCardCheck(citation._id)
                                      }
                                    />
                                    <Avatar
                                      sx={{
                                        bgcolor: "primary.light",
                                        width: 48,
                                        height: 48,
                                      }}
                                    >
                                      {getSourceIcon(citation.sourceType)}
                                    </Avatar>
                                    <Box sx={{ flex: 1 }}>
                                      <Typography
                                        variant="h6"
                                        fontWeight="600"
                                        gutterBottom
                                      >
                                        {citation.title}
                                      </Typography>
                                      <Typography
                                        variant="body2"
                                        color="text.secondary"
                                        sx={{ mb: 2 }}
                                      >
                                        {citation.fullCitation}
                                      </Typography>
                                      <Box
                                        sx={{
                                          display: "flex",
                                          gap: 1,
                                          flexWrap: "wrap",
                                          alignItems: "center",
                                        }}
                                      >
                                        <Chip
                                          size="small"
                                          label={citation.sourceType}
                                          color="primary"
                                          variant="outlined"
                                          sx={{ borderRadius: 1.5 }}
                                        />
                                        {citation.publicationDate.year && (
                                          <Chip
                                            size="small"
                                            label={
                                              citation.publicationDate.year
                                            }
                                            sx={{ borderRadius: 1.5 }}
                                          />
                                        )}
                                        <Chip
                                          size="small"
                                          label={citation.textStyle}
                                          color="secondary"
                                          variant="outlined"
                                          sx={{ borderRadius: 1.5 }}
                                        />
                                      </Box>
                                    </Box>
                                    <IconButton
                                      onClick={(e) =>
                                        handleCardMenu(e, citation._id)
                                      }
                                    >
                                      <MoreVert />
                                    </IconButton>
                                  </Box>
                                </CardContent>
                                <Divider />
                                <CardActions
                                  sx={{ justifyContent: "flex-end", p: 2 }}
                                >
                                  <Button
                                    size="small"
                                    startIcon={<FileCopy />}
                                    onClick={() => handleCopyCitation(citation)}
                                    sx={{ textTransform: "none" }}
                                  >
                                    Copy
                                  </Button>
                                  <Button
                                    size="small"
                                    startIcon={<Delete />}
                                    color="error"
                                    onClick={() =>
                                      handleDeleteCitation(citation._id)
                                    }
                                    sx={{ textTransform: "none" }}
                                  >
                                    Delete
                                  </Button>
                                </CardActions>
                              </Card>
                            </Grid2>
                          ))}
                        </Grid2>
                      </>
                    )}
                  </Box>
                ),
              )
            ) : (
              <Grid2 container spacing={3}>
                {citations.map((citation) => (
                  <Grid2 xs={12} key={citation._id}>
                    <Card
                      elevation={0}
                      sx={{
                        border: "2px solid",
                        borderColor: citation.isChecked
                          ? "primary.main"
                          : "divider",
                        borderRadius: 3,
                        transition: "all 0.3s",
                        "&:hover": {
                          borderColor: "primary.main",
                          transform: "translateY(-2px)",
                          boxShadow: "0 4px 20px rgba(0,0,0,0.1)",
                        },
                      }}
                    >
                      <CardContent>
                        <Box
                          sx={{
                            display: "flex",
                            alignItems: "flex-start",
                            gap: 2,
                          }}
                        >
                          <Checkbox
                            checked={citation.isChecked || false}
                            onChange={() => handleCardCheck(citation._id)}
                          />
                          <Avatar
                            sx={{
                              bgcolor: "primary.light",
                              width: 48,
                              height: 48,
                            }}
                          >
                            {getSourceIcon(citation.sourceType)}
                          </Avatar>
                          <Box sx={{ flex: 1 }}>
                            <Typography
                              variant="h6"
                              fontWeight="600"
                              gutterBottom
                            >
                              {citation.title}
                            </Typography>
                            <Typography
                              variant="body2"
                              color="text.secondary"
                              sx={{ mb: 2 }}
                            >
                              {citation.fullCitation}
                            </Typography>
                            <Box
                              sx={{
                                display: "flex",
                                gap: 1,
                                flexWrap: "wrap",
                                alignItems: "center",
                              }}
                            >
                              <Chip
                                size="small"
                                label={citation.sourceType}
                                color="primary"
                                variant="outlined"
                                sx={{ borderRadius: 1.5 }}
                              />
                              {citation.publicationDate.year && (
                                <Chip
                                  size="small"
                                  label={citation.publicationDate.year}
                                  sx={{ borderRadius: 1.5 }}
                                />
                              )}
                              <Chip
                                size="small"
                                label={citation.textStyle}
                                color="secondary"
                                variant="outlined"
                                sx={{ borderRadius: 1.5 }}
                              />
                            </Box>
                          </Box>
                          <IconButton
                            onClick={(e) => handleCardMenu(e, citation._id)}
                          >
                            <MoreVert />
                          </IconButton>
                        </Box>
                      </CardContent>
                      <Divider />
                      <CardActions sx={{ justifyContent: "flex-end", p: 2 }}>
                        <Button
                          size="small"
                          startIcon={<FileCopy />}
                          onClick={() => handleCopyCitation(citation)}
                          sx={{ textTransform: "none" }}
                        >
                          Copy
                        </Button>
                        <Button
                          size="small"
                          startIcon={<Delete />}
                          color="error"
                          onClick={() => handleDeleteCitation(citation._id)}
                          sx={{ textTransform: "none" }}
                        >
                          Delete
                        </Button>
                      </CardActions>
                    </Card>
                  </Grid2>
                ))}
              </Grid2>
            )}

            {citations.length === 0 && (
              <Box sx={{ textAlign: "center", py: 8 }}>
                <Description
                  sx={{ fontSize: 64, color: "text.disabled", mb: 2 }}
                />
                <Typography variant="h6" color="text.secondary" gutterBottom>
                  No citations found
                </Typography>
                <Typography variant="body2" color="text.secondary">
                  Try adjusting your search or create a new citation
                </Typography>
              </Box>
            )}
          </Paper>

          {/* Download Menu */}
          <Menu
            anchorEl={downloadAnchor}
            open={Boolean(downloadAnchor)}
            onClose={() => setDownloadAnchor(null)}
            PaperProps={{
              sx: {
                borderRadius: 2,
                mt: 1,
              },
            }}
          >
            <MenuItem onClick={() => handleDownload("MS-Word")}>
              <CloudDownload sx={{ mr: 1 }} /> MS-Word
            </MenuItem>
            {/* <MenuItem onClick={() => handleDownload("BibTeX")}>
              <CloudDownload sx={{ mr: 1 }} /> BibTeX
            </MenuItem> */}
            <MenuItem onClick={() => handleDownload("PDF")}>
              <CloudDownload sx={{ mr: 1 }} /> PDF
            </MenuItem>
          </Menu>

          {/* Group By Menu */}
          <Menu
            anchorEl={groupByAnchor}
            open={Boolean(groupByAnchor)}
            onClose={() => setGroupByAnchor(null)}
            PaperProps={{
              sx: {
                borderRadius: 2,
                mt: 1,
              },
            }}
          >
            <MenuItem onClick={() => handleGroupBy("No Group")}>
              No Group
            </MenuItem>
            <MenuItem onClick={() => handleGroupBy("Source Type")}>
              Source Type
            </MenuItem>
            <MenuItem onClick={() => handleGroupBy("Published Year")}>
              Published Year
            </MenuItem>
          </Menu>

          {/* Card Options Menu - UPDATED */}
          <Menu
            anchorEl={cardMenuAnchor}
            open={Boolean(cardMenuAnchor)}
            onClose={handleCloseCardMenu}
            PaperProps={{
              sx: {
                borderRadius: 2,
                mt: 1,
              },
            }}
          >
            <MenuItem
              onClick={() => {
                const citation = citations.find(
                  (c) => c._id === selectedCardId,
                );
                if (citation) handleOpenEditModal(citation);
              }}
            >
              <Edit sx={{ mr: 1, fontSize: 20 }} />
              Edit
            </MenuItem>
            <MenuItem
              onClick={() => {
                const citation = citations.find(
                  (c) => c._id === selectedCardId,
                );
                if (citation) handleViewSource(citation.url);
                handleCloseCardMenu();
              }}
            >
              <OpenInNew sx={{ mr: 1, fontSize: 20 }} />
              View Source
            </MenuItem>
          </Menu>

          {/* Manual Citation Modal */}
          <Dialog
            open={showManualModal}
            onClose={handleCloseManualModal}
            maxWidth="md"
            fullWidth
            sx={{ zIndex: 10001 }}
            PaperProps={{
              sx: {
                borderRadius: 3,
              },
            }}
          >
            <DialogTitle
              sx={{ bgcolor: "primary.main", color: "white", fontWeight: 600 }}
            >
              {selectedTab === 0
                ? "Webpage"
                : selectedTab === 1
                  ? "Journal Article"
                  : "Book"}
              <IconButton
                onClick={handleCloseManualModal}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "white",
                }}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Grid2 container spacing={2} marginTop={2}>
                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="Title"
                    value={formData.title}
                    onChange={(e) =>
                      setFormData({ ...formData, title: e.target.value })
                    }
                    required
                  />
                </Grid2>
                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="Description"
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                    multiline
                    rows={2}
                  />
                </Grid2>
                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="Website Name"
                    value={formData.websiteName}
                    onChange={(e) =>
                      setFormData({ ...formData, websiteName: e.target.value })
                    }
                  />
                </Grid2>

                {/* Contributors */}
                <Grid2 xs={12}>
                  <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                    Contributors
                  </Typography>
                  {formData.contributors.map((contributor, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: 2,
                        p: 2,
                        bgcolor: "black.100",
                        borderRadius: 2,
                      }}
                    >
                      <Grid2 container spacing={2}>
                        <Grid2 xs={6}>
                          <TextField
                            fullWidth
                            label="First Name"
                            value={contributor.firstName}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "firstName",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={6}>
                          <TextField
                            fullWidth
                            label="Last Name"
                            value={contributor.lastName}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "lastName",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={4}>
                          <TextField
                            fullWidth
                            label="Middle Name"
                            value={contributor.middleName}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "middleName",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={4}>
                          <TextField
                            fullWidth
                            label="Suffix"
                            value={contributor.suffix}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "suffix",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={4}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              height: "100%",
                            }}
                          >
                            {formData.contributors.length > 1 && (
                              <IconButton
                                color="error"
                                onClick={() => handleRemoveContributor(index)}
                              >
                                <Delete />
                              </IconButton>
                            )}
                          </Box>
                        </Grid2>
                      </Grid2>
                    </Box>
                  ))}
                  <Button
                    startIcon={<Add />}
                    onClick={handleAddContributor}
                    sx={{ textTransform: "none" }}
                  >
                    Add Member +
                  </Button>
                </Grid2>

                {/* Publication Date */}
                <Grid2 xs={12}>
                  <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                    Publication Date
                  </Typography>
                </Grid2>
                <Grid2 xs={4}>
                  <TextField
                    fullWidth
                    label="Year"
                    value={formData.publicationDate.year}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        publicationDate: {
                          ...formData.publicationDate,
                          year: e.target.value,
                        },
                      })
                    }
                  />
                </Grid2>
                <Grid2 xs={4}>
                  <FormControl fullWidth>
                    <InputLabel>Month</InputLabel>
                    <Select
                      value={formData.publicationDate.month}
                      label="Month"
                      MenuProps={{
                        disablePortal: true,
                        PaperProps: {
                          sx: { zIndex: 90000 },
                        },
                      }}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          publicationDate: {
                            ...formData.publicationDate,
                            month: e.target.value,
                          },
                        })
                      }
                    >
                      <MenuItem value="">-</MenuItem>
                      <MenuItem value="01">January</MenuItem>
                      <MenuItem value="02">February</MenuItem>
                      <MenuItem value="03">March</MenuItem>
                      <MenuItem value="04">April</MenuItem>
                      <MenuItem value="05">May</MenuItem>
                      <MenuItem value="06">June</MenuItem>
                      <MenuItem value="07">July</MenuItem>
                      <MenuItem value="08">August</MenuItem>
                      <MenuItem value="09">September</MenuItem>
                      <MenuItem value="10">October</MenuItem>
                      <MenuItem value="11">November</MenuItem>
                      <MenuItem value="12">December</MenuItem>
                    </Select>
                  </FormControl>
                </Grid2>
                <Grid2 xs={4}>
                  <TextField
                    fullWidth
                    label="Day"
                    value={formData.publicationDate.day}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        publicationDate: {
                          ...formData.publicationDate,
                          day: e.target.value,
                        },
                      })
                    }
                  />
                </Grid2>

                {/* Access Date */}
                <Grid2 xs={12}>
                  <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                    Access Date
                  </Typography>
                </Grid2>
                <Grid2 xs={4}>
                  <TextField
                    fullWidth
                    label="Year"
                    value={formData.accessDate.year}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        accessDate: {
                          ...formData.accessDate,
                          year: e.target.value,
                        },
                      })
                    }
                  />
                </Grid2>
                <Grid2 xs={4}>
                  <FormControl fullWidth>
                    <InputLabel>Month</InputLabel>
                    <Select
                      value={formData.accessDate.month}
                      label="Month"
                      MenuProps={{
                        disablePortal: true,
                        PaperProps: {
                          sx: { zIndex: 30001 },
                        },
                      }}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          accessDate: {
                            ...formData.accessDate,
                            month: e.target.value,
                          },
                        })
                      }
                    >
                      <MenuItem value="">-</MenuItem>
                      <MenuItem value="01">January</MenuItem>
                      <MenuItem value="02">February</MenuItem>
                      <MenuItem value="03">March</MenuItem>
                      <MenuItem value="04">April</MenuItem>
                      <MenuItem value="05">May</MenuItem>
                      <MenuItem value="06">June</MenuItem>
                      <MenuItem value="07">July</MenuItem>
                      <MenuItem value="08">August</MenuItem>
                      <MenuItem value="09">September</MenuItem>
                      <MenuItem value="10">October</MenuItem>
                      <MenuItem value="11">November</MenuItem>
                      <MenuItem value="12">December</MenuItem>
                    </Select>
                  </FormControl>
                </Grid2>
                <Grid2 xs={4}>
                  <TextField
                    fullWidth
                    label="Day"
                    value={formData.accessDate.day}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        accessDate: {
                          ...formData.accessDate,
                          day: e.target.value,
                        },
                      })
                    }
                  />
                </Grid2>

                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="URL"
                    value={formData.url}
                    onChange={(e) =>
                      setFormData({ ...formData, url: e.target.value })
                    }
                    placeholder="Enter the source URL for this citation"
                  />
                </Grid2>
              </Grid2>
            </DialogContent>
            <DialogActions sx={{ p: 3 }}>
              <Button
                onClick={handleCloseManualModal}
                sx={{ textTransform: "none" }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSaveManualCitation}
                variant="contained"
                sx={{
                  textTransform: "none",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                }}
              >
                Save Citations
              </Button>
            </DialogActions>
          </Dialog>

          {/* Edit Citation Modal */}
          <Dialog
            open={showEditModal}
            onClose={handleCloseEditModal}
            maxWidth="md"
            fullWidth
            sx={{ zIndex: 10001 }}
            PaperProps={{
              sx: {
                borderRadius: 3,
              },
            }}
          >
            <DialogTitle
              sx={{ bgcolor: "primary.main", color: "white", fontWeight: 600 }}
            >
              Edit Citation
              <IconButton
                onClick={handleCloseEditModal}
                sx={{
                  position: "absolute",
                  right: 8,
                  top: 8,
                  color: "white",
                }}
              >
                <Close />
              </IconButton>
            </DialogTitle>
            <DialogContent>
              <Grid2 container spacing={2} marginTop={2}>
                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="Title"
                    value={formData.title}
                    onChange={(e) =>
                      setFormData({ ...formData, title: e.target.value })
                    }
                    required
                  />
                </Grid2>
                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="Description"
                    value={formData.description}
                    onChange={(e) =>
                      setFormData({ ...formData, description: e.target.value })
                    }
                    multiline
                    rows={2}
                  />
                </Grid2>
                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="Website Name"
                    value={formData.websiteName}
                    onChange={(e) =>
                      setFormData({ ...formData, websiteName: e.target.value })
                    }
                  />
                </Grid2>

                {/* Contributors */}
                <Grid2 xs={12}>
                  <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                    Contributors
                  </Typography>
                  {formData.contributors.map((contributor, index) => (
                    <Box
                      key={index}
                      sx={{
                        mb: 2,
                        p: 2,
                        bgcolor: "black.100",
                        borderRadius: 2,
                      }}
                    >
                      <Grid2 container spacing={2}>
                        <Grid2 xs={6}>
                          <TextField
                            fullWidth
                            label="First Name"
                            value={contributor.firstName}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "firstName",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={6}>
                          <TextField
                            fullWidth
                            label="Last Name"
                            value={contributor.lastName}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "lastName",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={4}>
                          <TextField
                            fullWidth
                            label="Middle Name"
                            value={contributor.middleName}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "middleName",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={4}>
                          <TextField
                            fullWidth
                            label="Suffix"
                            value={contributor.suffix}
                            onChange={(e) =>
                              handleUpdateContributor(
                                index,
                                "suffix",
                                e.target.value,
                              )
                            }
                          />
                        </Grid2>
                        <Grid2 xs={4}>
                          <Box
                            sx={{
                              display: "flex",
                              alignItems: "center",
                              height: "100%",
                            }}
                          >
                            {formData.contributors.length > 1 && (
                              <IconButton
                                color="error"
                                onClick={() => handleRemoveContributor(index)}
                              >
                                <Delete />
                              </IconButton>
                            )}
                          </Box>
                        </Grid2>
                      </Grid2>
                    </Box>
                  ))}
                  <Button
                    startIcon={<Add />}
                    onClick={handleAddContributor}
                    sx={{ textTransform: "none" }}
                  >
                    Add Member +
                  </Button>
                </Grid2>

                {/* Publication Date */}
                <Grid2 xs={12}>
                  <Typography variant="subtitle1" fontWeight="600" gutterBottom>
                    Publication Date
                  </Typography>
                </Grid2>
                <Grid2 xs={4}>
                  <TextField
                    fullWidth
                    label="Year"
                    value={formData.publicationDate.year}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        publicationDate: {
                          ...formData.publicationDate,
                          year: e.target.value,
                        },
                      })
                    }
                  />
                </Grid2>
                <Grid2 xs={4}>
                  <FormControl fullWidth>
                    <InputLabel>Month</InputLabel>
                    <Select
                      value={formData.publicationDate.month}
                      label="Month"
                      MenuProps={{
                        disablePortal: true,
                        PaperProps: {
                          sx: { zIndex: 20000 },
                        },
                      }}
                      onChange={(e) =>
                        setFormData({
                          ...formData,
                          publicationDate: {
                            ...formData.publicationDate,
                            month: e.target.value,
                          },
                        })
                      }
                    >
                      <MenuItem value="">-</MenuItem>
                      <MenuItem value="01">January</MenuItem>
                      <MenuItem value="02">February</MenuItem>
                      <MenuItem value="03">March</MenuItem>
                      <MenuItem value="04">April</MenuItem>
                      <MenuItem value="05">May</MenuItem>
                      <MenuItem value="06">June</MenuItem>
                      <MenuItem value="07">July</MenuItem>
                      <MenuItem value="08">August</MenuItem>
                      <MenuItem value="09">September</MenuItem>
                      <MenuItem value="10">October</MenuItem>
                      <MenuItem value="11">November</MenuItem>
                      <MenuItem value="12">December</MenuItem>
                    </Select>
                  </FormControl>
                </Grid2>
                <Grid2 xs={4}>
                  <TextField
                    fullWidth
                    label="Day"
                    value={formData.publicationDate.day}
                    onChange={(e) =>
                      setFormData({
                        ...formData,
                        publicationDate: {
                          ...formData.publicationDate,
                          day: e.target.value,
                        },
                      })
                    }
                  />
                </Grid2>

                <Grid2 xs={12}>
                  <TextField
                    fullWidth
                    label="URL"
                    value={formData.url}
                    onChange={(e) =>
                      setFormData({ ...formData, url: e.target.value })
                    }
                    placeholder="Enter the source URL for this citation"
                  />
                </Grid2>
              </Grid2>
            </DialogContent>
            <DialogActions sx={{ p: 3 }}>
              <Button
                onClick={handleCloseEditModal}
                sx={{ textTransform: "none" }}
              >
                Cancel
              </Button>
              <Button
                onClick={handleSaveEditCitation}
                variant="contained"
                sx={{
                  textTransform: "none",
                  background:
                    "linear-gradient(135deg, #667eea 0%, #764ba2 100%)",
                }}
              >
                Update Citation
              </Button>
            </DialogActions>
          </Dialog>
        </Container>
      </Box>
      <Box
        sx={{
          position: "fixed",
          top: 30,
          right: 28,
          width: 60,
          height: 60,
          display: "flex",
          alignItems: "center",
          justifyContent: "center",
          zIndex: 10002,
        }}
      >
        {[0, 1, 2].map((i) => (
          <Box
            key={i}
            sx={{
              position: "absolute",
              width: 60,
              height: 60,
              borderRadius: "50%",
              border: "2.5px solid rgba(102,126,234,0.5)",
              animation: "sdWave 2s ease-out infinite",
              animationDelay: `${i * 0.6}s`,
              "@keyframes sdWave": {
                "0%": { transform: "scale(1)", opacity: 0.8 },
                "100%": { transform: "scale(2.3)", opacity: 0 },
              },
            }}
          />
        ))}
        <LightTooltip title="AI SmartDesk" placement="left">
          <Box
            onClick={() => setSdOpen(true)}
            sx={{
              position: "relative",
              zIndex: 2,
              width: 60,
              height: 60,
              borderRadius: "50%",
              background: "linear-gradient(135deg,#667eea,#764ba2)",
              display: "flex",
              alignItems: "center",
              justifyContent: "center",
              cursor: "pointer",
              animation: "sdPulse 3s ease-in-out infinite",
              "@keyframes sdPulse": {
                "0%,100%": { transform: "scale(1)" },
                "50%": { transform: "scale(1.07)" },
              },
              "&:hover": {
                transform: "scale(1.12) !important",
                boxShadow: "0 8px 24px rgba(102,126,234,0.5)",
              },
              transition: "box-shadow .2s",
            }}
          >
            <Psychology sx={{ color: "white", fontSize: 28 }} />
          </Box>
        </LightTooltip>
      </Box>

      {/* ── SmartDesk Dialog ── */}
      <Dialog
        open={sdOpen}
        onClose={() => {
          setSdOpen(false);
          setSdEditingId(null);
        }}
        maxWidth={false}
        sx={{ zIndex: 10003 }}
        PaperProps={{
          sx: {
            width: 480,
            height: 600,
            borderRadius: 4,
            display: "flex",
            flexDirection: "column",
            overflow: "hidden",
            background: isDarkMode ? "#1e293b" : "#fff",
            boxShadow: "0 32px 80px rgba(0,0,0,0.22)",
          },
        }}
      >
        {/* Header */}
        <Box
          sx={{
            px: 2,
            py: 1.5,
            background: "linear-gradient(135deg,#667eea,#764ba2)",
            display: "flex",
            alignItems: "center",
            gap: 1.5,
            flexShrink: 0,
          }}
        >
          <Avatar
            sx={{ bgcolor: "rgba(255,255,255,0.2)", width: 38, height: 38 }}
          >
            <Psychology sx={{ fontSize: 22, color: "white" }} />
          </Avatar>
          <Box sx={{ flex: 1 }}>
            <Typography
              variant="subtitle1"
              sx={{
                color: "white",
                fontWeight: 600,
                lineHeight: 1.2,
                fontSize: "0.9rem",
              }}
            >
              AI SmartDesk
            </Typography>
            <Typography
              variant="caption"
              sx={{
                color: "rgba(255,255,255,0.85)",
                display: "flex",
                alignItems: "center",
                gap: 0.5,
              }}
            >
              <Box
                sx={{
                  width: 7,
                  height: 7,
                  borderRadius: "50%",
                  bgcolor: "#4ade80",
                  display: "inline-block",
                }}
              />
              Online · Ready to assist
            </Typography>
          </Box>
          <IconButton
            size="small"
            onClick={() => {
              setSdOpen(false);
              setSdEditingId(null);
            }}
            sx={{
              bgcolor: "rgba(255,255,255,0.18)",
              color: "white",
              "&:hover": { bgcolor: "rgba(255,255,255,0.3)" },
              width: 30,
              height: 30,
            }}
          >
            <CloseIcon sx={{ fontSize: 15 }} />
          </IconButton>
        </Box>

        {/* Messages */}
        <Box
          sx={{
            flex: 1,
            overflowY: "auto",
            p: 1.75,
            display: "flex",
            flexDirection: "column",
            gap: 1.5,
            bgcolor: isDarkMode ? "#0f172a" : "#f8fafc",
            "&::-webkit-scrollbar": { width: 4 },
            "&::-webkit-scrollbar-thumb": {
              bgcolor: "rgba(102,126,234,0.25)",
              borderRadius: 4,
            },
          }}
        >
          {sdConv.length === 0 && !sdLoading ? (
            <Box
              sx={{
                flex: 1,
                display: "flex",
                flexDirection: "column",
                alignItems: "center",
                justifyContent: "center",
                gap: 1.5,
                textAlign: "center",
                py: 3,
                minHeight: 320,
              }}
            >
              <Box
                sx={{
                  width: 58,
                  height: 58,
                  borderRadius: 3,
                  bgcolor: "rgba(102,126,234,0.09)",
                  border: "1px solid rgba(102,126,234,0.18)",
                  display: "flex",
                  alignItems: "center",
                  justifyContent: "center",
                }}
              >
                <Psychology sx={{ fontSize: 28, color: "#667eea" }} />
              </Box>
              <Typography
                variant="body2"
                sx={{
                  fontWeight: 600,
                  color: isDarkMode ? "white" : "#0f172a",
                }}
              >
                Hello! I'm your AI assistant
              </Typography>
              <Typography
                variant="caption"
                sx={{ color: "#64748b", maxWidth: 210, lineHeight: 1.6 }}
              >
                Ask me anything or pick a quick prompt
              </Typography>
            </Box>
          ) : (
            sdConv.map((msg) => {
              const isUser = msg.type === "user";
              const isEditing = sdEditingId === msg.id;
              return (
                <Box
                  key={msg.id}
                  sx={{
                    display: "flex",
                    justifyContent: isUser ? "flex-end" : "flex-start",
                    gap: 1,
                    alignItems: "flex-end",
                  }}
                >
                  {!isUser && (
                    <Avatar
                      sx={{
                        width: 28,
                        height: 28,
                        bgcolor: "#764ba2",
                        fontSize: "0.62rem",
                        fontWeight: 700,
                      }}
                    >
                      AI
                    </Avatar>
                  )}
                  <Box sx={{ maxWidth: "72%" }}>
                    <Paper
                      elevation={0}
                      sx={{
                        px: 1.5,
                        py: 1,
                        fontSize: "0.8rem",
                        lineHeight: 1.65,
                        whiteSpace: "pre-wrap",
                        borderRadius: isUser
                          ? "14px 4px 14px 14px"
                          : "4px 14px 14px 14px",
                        background: isUser
                          ? "linear-gradient(135deg,#667eea,#764ba2)"
                          : isDarkMode
                            ? "#1e293b"
                            : "#fff",
                        color: isUser
                          ? "white"
                          : isDarkMode
                            ? "#e2e8f0"
                            : "#0f172a",
                        border: !isUser
                          ? `0.5px solid ${isDarkMode ? "#334155" : "rgba(0,0,0,0.09)"}`
                          : "none",
                      }}
                    >
                      <Typography
                        variant="body2"
                        sx={{
                          fontSize: "0.8rem",
                          lineHeight: 1.65,
                          whiteSpace: "pre-wrap",
                        }}
                      >
                        {msg.content}
                        {msg.edited && (
                          <Box
                            component="span"
                            sx={{
                              fontSize: "0.65rem",
                              color: isUser
                                ? "rgba(255,255,255,0.7)"
                                : "#f59e0b",
                              ml: 0.5,
                            }}
                          >
                            (edited)
                          </Box>
                        )}
                      </Typography>
                    </Paper>

                    {isEditing && (
                      <Box
                        sx={{
                          mt: 0.75,
                          p: 1.25,
                          bgcolor: "#fffbf0",
                          border: "1px solid #fcd34d",
                          borderRadius: 2,
                        }}
                      >
                        <TextField
                          fullWidth
                          multiline
                          rows={3}
                          size="small"
                          value={sdEditContent}
                          onChange={(e) => setSdEditContent(e.target.value)}
                          sx={{
                            mb: 1,
                            "& .MuiOutlinedInput-root": {
                              fontSize: "0.78rem",
                              borderRadius: 2,
                            },
                          }}
                        />
                        <Stack
                          direction="row"
                          spacing={0.75}
                          justifyContent="flex-end"
                        >
                          <Button
                            size="small"
                            onClick={() => {
                              setSdEditingId(null);
                              setSdEditContent("");
                            }}
                            sx={{
                              fontSize: "0.72rem",
                              color: "#64748b",
                              borderColor: "rgba(0,0,0,0.15)",
                            }}
                            variant="outlined"
                          >
                            Cancel
                          </Button>
                          <Button
                            size="small"
                            onClick={sdSaveEdit}
                            variant="contained"
                            sx={{
                              fontSize: "0.72rem",
                              background: "#667eea",
                              "&:hover": { background: "#5a6fd6" },
                            }}
                          >
                            Save & resend
                          </Button>
                        </Stack>
                      </Box>
                    )}

                    <Typography
                      variant="caption"
                      sx={{
                        fontSize: "0.65rem",
                        color: "#94a3b8",
                        display: "block",
                        mt: 0.3,
                        textAlign: isUser ? "right" : "left",
                      }}
                    >
                      {msg.ts.toLocaleTimeString([], {
                        hour: "2-digit",
                        minute: "2-digit",
                      })}
                    </Typography>

                    <Box
                      sx={{
                        display: "flex",
                        gap: 0.5,
                        mt: 0.4,
                        justifyContent: isUser ? "flex-end" : "flex-start",
                        opacity: 1,
                        transition: "opacity .15s",
                        "&:hover": { opacity: 1 },
                      }}
                    >
                      {isUser && (
                        <LightTooltip title="Edit message">
                          <IconButton
                            size="small"
                            onClick={() => {
                              setSdEditingId(msg.id);
                              setSdEditContent(msg.content);
                            }}
                            sx={{
                              width: 24,
                              height: 24,
                              borderRadius: 1,
                              bgcolor: "rgba(102,126,234,0.1)",
                              "&:hover": { bgcolor: "rgba(102,126,234,0.22)" },
                            }}
                          >
                            <Edit sx={{ fontSize: 13, color: "#667eea" }} />
                          </IconButton>
                        </LightTooltip>
                      )}
                      <LightTooltip
                        title={isUser ? "Copy message" : "Copy response"}
                      >
                        <IconButton
                          size="small"
                          onClick={(e) => {
                            navigator.clipboard.writeText(msg.content);
                            const btn = e.currentTarget;
                            btn.style.background = "rgba(16,185,129,0.2)";
                            setTimeout(() => (btn.style.background = ""), 1800);
                            showToast(
                              isUser ? "Message copied!" : "Response copied!",
                              "success",
                            );
                          }}
                          sx={{
                            width: 24,
                            height: 24,
                            borderRadius: 1,
                            bgcolor: "rgba(16,185,129,0.1)",
                            "&:hover": { bgcolor: "rgba(16,185,129,0.22)" },
                          }}
                        >
                          <ContentCopyIcon
                            sx={{ fontSize: 13, color: "#10b981" }}
                          />
                        </IconButton>
                      </LightTooltip>
                    </Box>
                  </Box>
                  {isUser && (
                    <Avatar
                      sx={{
                        width: 28,
                        height: 28,
                        bgcolor: "#667eea",
                        fontSize: "0.62rem",
                        fontWeight: 700,
                      }}
                    >
                      U
                    </Avatar>
                  )}
                </Box>
              );
            })
          )}

          {sdLoading && (
            <Box sx={{ display: "flex", gap: 1, alignItems: "flex-end" }}>
              <Avatar
                sx={{
                  width: 28,
                  height: 28,
                  bgcolor: "#764ba2",
                  fontSize: "0.62rem",
                  fontWeight: 700,
                }}
              >
                AI
              </Avatar>
              <Paper
                elevation={0}
                sx={{
                  px: 1.5,
                  py: 1,
                  borderRadius: "4px 14px 14px 14px",
                  bgcolor: isDarkMode ? "#1e293b" : "#fff",
                  border: `0.5px solid ${isDarkMode ? "#334155" : "rgba(0,0,0,0.09)"}`,
                }}
              >
                <Box sx={{ display: "flex", gap: 0.6, alignItems: "center" }}>
                  {[0, 1, 2].map((i) => (
                    <Box
                      key={i}
                      sx={{
                        width: 7,
                        height: 7,
                        borderRadius: "50%",
                        bgcolor: "#a855f7",
                        animation: "sdBounce 1.2s infinite",
                        animationDelay: `${i * 0.18}s`,
                        "@keyframes sdBounce": {
                          "0%,60%,100%": { transform: "translateY(0)" },
                          "30%": { transform: "translateY(-5px)" },
                        },
                      }}
                    />
                  ))}
                </Box>
              </Paper>
            </Box>
          )}
          <div ref={sdEndRef} />
        </Box>

        {/* Word count */}
        {sdMsg && (
          <Typography
            variant="caption"
            sx={{
              px: 2,
              pb: 0.5,
              textAlign: "right",
              display: "block",
              color:
                sdMsg.trim().split(/\s+/).length > 1500 ? "#ef4444" : "#94a3b8",
              bgcolor: isDarkMode ? "#1e293b" : "#fff",
            }}
          >
            {sdMsg.trim().split(/\s+/).length} / 1500 words
          </Typography>
        )}

        {/* Input */}
        <Box
          sx={{
            p: 1.25,
            borderTop: `0.5px solid ${isDarkMode ? "#334155" : "rgba(0,0,0,0.08)"}`,
            display: "flex",
            gap: 1,
            alignItems: "flex-end",
            bgcolor: isDarkMode ? "#1e293b" : "#fff",
            flexShrink: 0,
          }}
        >
          <TextField
            fullWidth
            multiline
            maxRows={3}
            size="small"
            placeholder="Type your message… (Enter to send)"
            value={sdMsg}
            onChange={(e) => setSdMsg(e.target.value)}
            onKeyDown={(e) => {
              if (e.key === "Enter" && !e.shiftKey) {
                e.preventDefault();
                sdSend();
              }
            }}
            disabled={sdLoading}
            sx={{
              "& .MuiOutlinedInput-root": {
                borderRadius: 3,
                fontSize: "0.8rem",
                bgcolor: isDarkMode ? "#0f172a" : "#f8fafc",
              },
            }}
          />
          <IconButton
            onClick={() => sdSend()}
            disabled={!sdMsg.trim() || sdLoading}
            sx={{
              width: 36,
              height: 36,
              borderRadius: "50%",
              flexShrink: 0,
              mb: "2px",
              background:
                sdMsg.trim() && !sdLoading
                  ? "linear-gradient(135deg,#667eea,#764ba2)"
                  : "rgba(0,0,0,0.1)",
              color: sdMsg.trim() && !sdLoading ? "white" : "#94a3b8",
              "&:hover:not(:disabled)": { transform: "scale(1.08)" },
              "&:disabled": { background: "rgba(0,0,0,0.1)" },
            }}
          >
            <Send sx={{ fontSize: 16 }} />
          </IconButton>
        </Box>
      </Dialog>
    </>
  );
};
export default ModernCitationGenerator;
